// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUqi9EDm19u_X-BbjWmfTgU9JJxRiEaZY",
  authDomain: "cutlist-project-e578e.firebaseapp.com",
  projectId: "cutlist-project-e578e",
  storageBucket: "cutlist-project-e578e.firebasestorage.app",
  messagingSenderId: "385507510233",
  appId: "1:385507510233:web:110e7e6a4c2ddefa05fbc8",
  measurementId: "G-P4E81N51P7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Configure Facebook provider - only request public_profile (no email)
// Email scope requires Facebook App Review
const facebookProvider = new FacebookAuthProvider();

// Remove default scopes and only add public_profile
// This prevents Firebase from requesting email permission
facebookProvider.addScope('public_profile');

facebookProvider.setCustomParameters({
  'display': 'popup',
  'auth_type': ''
});

export { auth, db, googleProvider, facebookProvider };
